import baseApi from './baseApi';

const apiUrl = process.env.API_URL;

export const requests = {
  sendContactsFrom: (data, lang = 'ru') => baseApi.post(`${apiUrl}/landing/contact`, data, { headers: { 'X-Language': lang } }),
  sendResume: (data, lang = 'ru') => baseApi.post(`${apiUrl}/landing/resume`, data, { headers: { 'X-Language': lang } }),
};

export const queries = {
  getMailDomain: (mail) => baseApi.get(`${apiUrl}/maildomain?email=${mail}`),
  getAreasOfActivity: () => baseApi.get(`${apiUrl}/areasOfActivityPublic/all`),
};
